import { PermissionEntry } from "./permissionEntry";
import { UserGroupDto } from "./userGroupDto";

export class UserGroup {

    constructor(userGroupDto: UserGroupDto | null) {
        if(userGroupDto) {
            this.id = userGroupDto.id;
            this.companyLoginId = userGroupDto.companyLoginId;
            this.name = userGroupDto.name;
            this.roles = userGroupDto.roles;
            this.can_download = userGroupDto.can_download;
            this.can_view = userGroupDto.can_view;
            this.can_order = userGroupDto.can_order;
            this.permissions = new Map<string, PermissionEntry>(Object.entries(userGroupDto.permissions));
        }
    }
    id: number;
    companyLoginId: string;
    name: string;
    roles: Array<string>;
    permissions: Map<string, PermissionEntry>;
    can_download: boolean;
    can_view: boolean;
    can_order: boolean;
}